import { render } from "./CookieModalBlock.vue?vue&type=template&id=785ccf0c&scoped=true&ts=true"
import script from "./CookieModalBlock.vue?vue&type=script&lang=ts"
export * from "./CookieModalBlock.vue?vue&type=script&lang=ts"

import "./CookieModalBlock.vue?vue&type=style&index=0&id=785ccf0c&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-785ccf0c"]])

export default __exports__